import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import PrimaNota from "@/pages/PrimaNota";
import Riparazioni from "@/pages/Riparazioni";
import Clienti from "@/pages/Clienti";
import ClienteDettaglio from "@/pages/ClienteDettaglio";
import Ordini from "@/pages/Ordini";
import Prenotazioni from "@/pages/Prenotazioni";
import Messaggi from "@/pages/Messaggi";
import Dipendenti from "@/pages/Dipendenti";
import Statistiche from "@/pages/Statistiche";

const Protected = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="app-loading">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="prima-nota" element={<PrimaNota />} />
            <Route path="riparazioni" element={<Riparazioni />} />
            <Route path="clienti" element={<Clienti />} />
            <Route path="clienti/:id" element={<ClienteDettaglio />} />
            <Route path="ordini" element={<Ordini />} />
            <Route path="prenotazioni" element={<Prenotazioni />} />
            <Route path="messaggi" element={<Messaggi />} />
            <Route
              path="dipendenti"
              element={
                <Protected adminOnly>
                  <Dipendenti />
                </Protected>
              }
            />
            <Route
              path="statistiche"
              element={
                <Protected>
                  <Statistiche />
                </Protected>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
